<template>
  <div style="position: relative">

        <div class="num-box">
          <div class="img-box">
            <img class="num-img" :src="numImg" alt="">
            <i @click="refreshFun" class="iconfont icon-refresh" />
          </div>

        </div>
        <v-card-actions class="modal-bottom-box">
          <v-text-field
            v-model="inputNum"
            outlined
            dense
            @keyup.enter.native="handleOk"
            :label="$t('login.computationNum.result')"
          ></v-text-field>
              <v-btn
                style="margin-left: 10px"
                color="primary"
                @click="handleOk"
              >
                {{$t('btn.submit')}}
              </v-btn>
        </v-card-actions>


    </div>
</template>

<script>

import { aesEncrypt } from '@/components/verifition/utils/ase'
import store from '@/store'
import {
  mdiClose,
} from '@mdi/js'
export default {
    data() {
        return {
            numImg: '',
            inputNum: null,
            backToken: '',
            secretKey: '',
          icons: {

            mdiClose,

          },
        };
    },
    props: {
     visible: Boolean,
      verificationObject:{
        type: Object,
        default:null,
      },
    },
    created() {
        this.$root.eventHub.$on('verifyFun', (res)=> {
            this.reqCheck(res)
        })
    },
  watch: {
    // type变化则全面刷新
    visible: {
      immediate: true,
      handler() {

        this.numImg = 'data:image/png;base64,'+this.verificationObject.originalImageBase64
        this.backToken = this.verificationObject.token
        this.secretKey = this.verificationObject.secretKey


      }
    },
    // verificationObject: {
    //   immediate: true,
    //   handler() {
    //     console.log("verificationObject")
    //     this.numImg = 'data:image/png;base64,'+this.verificationObject.originalImageBase64
    //     this.backToken = this.verificationObject.token
    //     this.secretKey = this.verificationObject.secretKey
    //     //this.init()
    //
    //
    //   }
    // }
  },
    methods: {
        uuid() {
            var s = []
            var hexDigits = '0123456789abcdef'
            for (var i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
            }
            s[14] = '4'
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
            s[8] = s[13] = s[18] = s[23] = '-'
            var slider = 'answer' + '-' + s.join('')
            return slider
        },
        // getPictrue() {
        //     const data = {
        //       reqId:sessionStorage.getItem('reqId')
        //     }
        //     reqGet(data).then(res => {
        //         if (res.code == 200) {
        //             this.numImg = 'data:image/png;base64,'+res.data.originalImageBase64
        //             this.backToken = res.data.token
        //             this.secretKey = res.data.secretKey
        //         }
        //     })
        // },
        handleOk() {
            if(this.inputNum == null) {
                store.dispatch('snackbar/openSnackbar',{
                    snackbarText: this.$t('login.computationNum.resultErr'),
                    colorType: 'error'
                })
                return;
            }
            const data = {
              verifyCodeMode: 3,
                'pointJson': this.secretKey ? aesEncrypt(this.inputNum, this.secretKey) : this.inputNum,
                'token': this.backToken
            }
            this.$parent.$emit('success', data)
        },
        refreshFun() {
          this.inputNum = null
          this.$parent.$emit("refreshFun")
        },
        refresh: function() {
          this.inputNum = null

        },
        handleCancel() {
          this.$parent.closeBox()
        },
        reqCheck(res) {
            // 509 验证码错误 0 密码错误
            if (res.code == 0) {
                store.dispatch('snackbar/openSnackbar',{
                    snackbarText: res.message,
                    colorType: 'error'
                })
                this.handleCancel()
            } else if (res.code == 509) {
                store.dispatch('snackbar/openSnackbar',{
                    snackbarText: res.message,
                    colorType: 'error'
                })
                this.refreshFun()
            }
        }
    },
}
</script>

<style lang='scss' scoped>

::v-deep .v-text-field__details {
  min-height: 0px !important;
  .v-messages {
    display: none
  ;
  }
}
.modal-bottom-box {
height: 60px;
display: flex;

  align-items: flex-start;


}
::v-deep .v-card__actions {
  padding:16px 0px;
}
.img-box {
    position: relative;
    .num-img {
        width: 100%;
    }
    .icon-refresh {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
    }
    .icon-refresh:before {
        left: auto;
        bottom: auto;
        margin: 5px;
    }
}
</style>
